import { j as a } from "../../../jsx-runtime-B6kdoens.js";
import { a as c } from "../../../index-CROKJrb5.js";
import { c as n, f } from "../../../create-component-CBAeEoQ6.js";
import { IconRenderer as p } from "../../Icon/index.js";
import { useListStateAtoms as u } from "../ListState/index.js";
import { u as x } from "../../../react-B_GApDuV.js";
const R = n(
  "ListItemIcon",
  f(
    ({ className: t, icon: o, size: r, ...s }, e) => {
      const { sizeAtom: m } = u(), i = x(m);
      return /* @__PURE__ */ a.jsx(
        p,
        {
          icon: o,
          size: r || i,
          className: c("cur-flex cur-gap-2", t),
          ref: e,
          ...s
        }
      );
    }
  )
);
export {
  R as ListItemIcon
};
//# sourceMappingURL=index.js.map
